const BASE = process.env.REACT_APP_API_URL || '';

async function api(method, path, body) {
  const token = localStorage.getItem('organiser_token');
  const res = await fetch(`${BASE}${path}`, {
    method,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    ...(body ? { body: JSON.stringify(body) } : {}),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || `HTTP ${res.status}`);
  return data;
}

export const ticketsApi = {
  request: (method, path, body) => api(method, path, body),
  getEvents:       (p={})  => api('GET', `/api/tickets/events?${new URLSearchParams(p)}`),
  getEvent:        (slug)  => api('GET', `/api/tickets/events/${slug}`),
  initiateOrder:   (body)  => api('POST', '/api/tickets/orders/initiate', body),
  getOrder:        (ref)   => api('GET', `/api/tickets/orders/${ref}`),
  verifyTicket:    (uid)   => api('GET', `/api/tickets/verify/${uid}`),
  managerLogin:    (e,p)   => api('POST', '/api/tickets/manage/login', { email:e, password:p }),
  getMyEvents:     ()      => api('GET', '/api/tickets/manage/events'),
  createEvent:     (body)  => api('POST', '/api/tickets/manage/events', body),
  getEventStats:   (id)    => api('GET', `/api/tickets/manage/events/${id}/stats`),
  getAttendees:    (id,p)  => api('GET', `/api/tickets/manage/events/${id}/attendees?${new URLSearchParams(p||{})}`),
  processCheckin:  (u,e)   => api('POST', '/api/tickets/manage/checkin', { ticketUid:u, eventId:e }),
  resendTicket:    (uid)   => api('POST', `/api/tickets/manage/resend/${uid}`),
  getCheckins:     (id)    => api('GET', `/api/tickets/manage/checkins/${id}`),
  adminOverview:   ()      => api('GET', '/api/tickets/admin/overview'),
  adminEvents:     (p)     => api('GET', `/api/tickets/admin/events?${new URLSearchParams(p||{})}`),
  adminOrders:     (p)     => api('GET', `/api/tickets/admin/orders?${new URLSearchParams(p||{})}`),
  adminOrganisers: ()      => api('GET', '/api/tickets/admin/organisers'),
  approveOrg:      (id,d)  => api('PUT', `/api/tickets/admin/organisers/${id}/approve`, d),
  updateEvent:          (id,d) => api('PUT', `/api/tickets/manage/events/${id}`, d),
  validatePromo:        (code, eventId, amount) => api('POST', '/api/tickets/promo/validate', { code, eventId, amount }),
  initiateBankTransfer: (body) => api('POST', '/api/tickets/orders/bank-transfer', body),
  createStripeIntent:   (body) => api('POST', '/api/tickets/stripe/create-payment-intent', body),
  confirmStripe:        (body) => api('POST', '/api/tickets/stripe/confirm', body),
};
